module.exports = __webpack_public_path__ + "img/banner_formatos_tramites_externos.1b743b8c.jpg";